import { ContactsRoute } from 'routes';

export const EntPhysiciansRoute = `${ContactsRoute}/ear-nose-and-throats-physicians`;
export const GeneralPractitionersRoute = `${ContactsRoute}/general-practitioners`;
export const SuppliersRoute = `${ContactsRoute}/suppliers`;
export const VatCustomersRoute = `${ContactsRoute}/vat-customers`;
export const HifsRoute = `${ContactsRoute}/hifs`;
